import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Grid, Modal, Stack } from "@mui/material";
import { DefaultCard } from "../../assets/styled-components/card";
import CustomTextField from "../commoncomponents/CustomTextField";
import PageTitle from "../commoncomponents/PageTitle";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import {
  getAuthToken,
  getcompanyId,
  getFacilityId,
  getuserId,
} from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph, ifacSecurityURL } from "../../utility/apiURLS";
import axios from "axios";
import StaffReportView from "./StaffReportView";
import {
  setHeaderName,
  setSelectedIndex,
} from "../../redux/actions/userActions";
import { useDispatch } from "react-redux";
import PageLoader from "../commoncomponents/PageLoader";
import { useNavigate } from "react-router-dom";
import utilities from "../../utility/utilities";
import commonMessages from "../../utility/constant";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import { useAccess } from "../../AccessContext";
const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1250px",
  height: "100%",
  maxHeight: "calc(100% - 64px)",
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "5px",
  p: 4,
  overflowY: "auto",
  overflowX: "hidden",
};

const StaffReportFetch = ({ isPerformance }) => {
  const all = { label: "All", value: "All", id: 0 }
  const [gridApi, setGridApi] = useState({});
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(all);
  const [monthsOptions, setMonthsOptions] = useState([all]);
  const [hospital, setHospital] = useState("");
  const [hospitalOptions, setHospitalOptions] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [option, setOption] = useState(""); // Set default value here
  const childRef = useRef(null);
  const [selectedData, setSelectedData] = useState({});
  const [enableDownload, setEnableDownload] = useState(false);
  const [columns, setColumns] = useState([]);

  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, `${isPerformance ? "SDRT002" : "SDRT003"}`);

  const leveloptions = [
    { label: "Hospital", value: "Hospital", id: 1 },
    { label: "HQ", value: "HQ", id: 2 },
  ];
  const [level, setLevel] = useState(leveloptions[0]);
  const commonColumns = [
    {
      field: "hospitalName",
      headerName: "Hospital Name",
      minWidth: 300,
      cellStyle: { fontWeight: 550 },
    },
    {
      field: "employeeName",
      headerName: "Staff Name",
      minWidth: 300,
      cellStyle: { fontWeight: 550 },
    },
    {
      field: "employeeId",
      headerName: "Staff ID",
      minWidth: 150,
      cellStyle: { fontWeight: 550 },
    },
  ];

  const performanceColumns = [
    ...commonColumns,
    { field: "countW1", headerName: "W1", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW2", headerName: "W2", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW3", headerName: "W3", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW4", headerName: "W4", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW5", headerName: "W5", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW6", headerName: "W6", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW7", headerName: "W7", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW8", headerName: "W8", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW9", headerName: "W9", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW10", headerName: "W10", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW11", headerName: "W11", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "countW12", headerName: "W12", minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "totalCount", headerName: "Total", minWidth: 200, cellStyle: { textAlign: "right" } },
  ];

  const efficiencyColumns = [
    ...commonColumns,
    {
      field: "totalCount",
      headerName: "Number of Service Request",
      minWidth: 200, cellStyle: { textAlign: "right" }
    },
    {
      field: "completedcount",
      headerName: "Completed",
      minWidth: 200, cellStyle: { textAlign: "right" }
    },
    {
      field: "pendingCount",
      headerName: "Pending",
      minWidth: 200, cellStyle: { textAlign: "right" }
    },
    {
      field: "completedPercentage",
      headerName: "Efficiency",
      minWidth: 200, cellStyle: { textAlign: "right" }
    },
  ];


  const allMonths = commonMessages.months;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const token = getAuthToken("id_token");
  const userId = getuserId("userId");
  const companyId = getcompanyId("companyId");
  const facilityId = getFacilityId("facilityId");
  const [isView, setIsView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const config = {
    headers: {
      // Attach bearer token to request header
      Authorization: `Bearer ${token}`,
    },
  };
  const yearsOptions = Array.from(
    { length: currentYear - 2016 + 1 },
    (_, i) => ({
      label: (2016 + i).toString(),
      value: (2016 + i).toString(),
    })
  );

  useEffect(() => {
    setYear({ label: currentYear.toString(), value: currentYear.toString() });
    setMonthsOptions([all, ...allMonths.slice(0, new Date().getMonth() + 1)]); // Up to current month
    if (isPerformance) {
      setColumns(performanceColumns);
      setOption("Staff Performance");
    } else {
      setColumns(efficiencyColumns);
      setOption("Staff Efficiency");
    }

  }, []);

  useEffect(() => {
    fetchOptions();
    setHospital(hospitalOptions.find((option) => option.id === facilityId));
  }, []);
  const fetchOptions = async () => {
    try {
      const response = await axios.get(
        `${ifacSecurityURL}/api/GraphUserdetails/GetAllFacilityDetailsByCompanyIdAndUserId/${companyId}/${userId}?size=100`,
        config
      );
      const options = response.data.map((item) => ({
        ...item,
        label: item.facilityName,
        value: item.facilityName,
        id: item.facilityId,
      }));

      setHospitalOptions(options);
      const selectedHospital = options.find(
        (option) => option.id === facilityId
      );
      setHospital(selectedHospital);
    } catch (error) {
      console.error("Failed to fetch hospital data:", error);
    }
  };

  const handleYearChange = (newValue) => {
    if (newValue) {
      if (newValue.value !== year.value) {
        setYear(newValue);
        const selectedYear = parseInt(newValue.value);
        const months =
          selectedYear === currentYear
            ? allMonths.slice(0, new Date().getMonth() + 1) // Up to current month for the current year
            : allMonths; // Full year for any other year
        setMonthsOptions([all, ...months]);
        setMonth(all)
      }
    }
  };

  const handleMonthChange = (newValue) => {
    setMonth(newValue);
  };

  const handleOptionChange = (newValue) => {
    setOption(newValue);
  };

  const handleLevelChange = (newValue) => {
    if (newValue) {
      if (newValue?.value === "HQ") {
        setHospital("");
      } else {
        setHospital(hospitalOptions.find((option) => option.id === facilityId));
      }
      setLevel(newValue);
    }
  };

  const handleRefresh = () => {
    setLevel(leveloptions[0]);
    setYear({ label: currentYear.toString(), value: currentYear.toString() });
    setMonth(all);
    setSelectedData({});
    setHospital(hospitalOptions.find((option) => option.id === facilityId));
    setEnableDownload(false);
    utilities.refreshGrid(gridApi);
  };

  const mergedMap = new Map();

  // Helper function to generate key from hospitalId and employeeId
  const generateKey = (item) => `${item.hospitalId}-${item.employeeId}`;

  // Helper function to add an item to the map
  const addToMapPer = (item) => {
    const key = generateKey(item);
    if (mergedMap.has(key)) {
      const existingItem = mergedMap.get(key);
      existingItem.totalCount += item.totalCount;
      for (let i = 1; i <= 12; i++) {
        existingItem[`countW${i}`] += item[`countW${i}`];
      }
    } else {
      mergedMap.set(key, { ...item });
    }
  };

  const addToMapEff = (item) => {
    const key = generateKey(item);
    if (mergedMap.has(key)) {
      const existingItem = mergedMap.get(key);
      existingItem.totalCount += item.totalCount;
      existingItem.completedcount += item.completedcount;
      existingItem.pendingCount += item.pendingCount;
      // Calculate new completedPercentage as a weighted average and round to two decimal places
      const totalTasks = existingItem.totalCount + item.totalCount;
      const newPercentage =
        (existingItem.completedPercentage * existingItem.totalCount +
          item.completedPercentage * item.totalCount) /
        totalTasks;
      existingItem.completedPercentage = parseFloat(newPercentage.toFixed(2));
    } else {
      mergedMap.set(key, { ...item });
    }
  };

  const handleGetResultClick = async () => {
    setLoading(true);
    setSelectedData("")
    if (isPerformance) {
      try {
        if (level.value === "HQ") {
          const [femResponse, bemResponse] = await Promise.all([
            axios.get(
              `${FemsGraph}/api/EmployeeReport/AllEmployeeReportlistfem/${year.value}/${month?.label ? month.id : 0}/${companyId}/${userId}`,
              config
            ),
            axios.get(
              `${BemsGraph}/api/EmployeeReport/AllEmployeeReportlistbem/${year.value}/${month?.label ? month.id : 0}/${companyId}/${userId}`,
              config
            ),
          ]);
          processData(femResponse, bemResponse);
        } else {
          try {
            const [femResponse, bemResponse] = await Promise.all([
              axios.get(
                `${FemsGraph}/api/EmployeeReport/EmployeeReportlistfem/${hospital.id}/${year.value}/${month?.label ? month.id : 0}`,
                config
              ),
              axios.get(
                `${BemsGraph}/api/EmployeeReport/EmployeeReportlistbem/${hospital.id}/${year.value}/${month?.label ? month.id : 0}`,
                config
              ),
            ]);
            processData(femResponse, bemResponse);
          } catch (err) {
            console.log(err);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        if (level.value === "HQ") {
          const [femResponse, bemResponse] = await Promise.all([
            axios.get(
              `${FemsGraph}/api/EmployeeReport/AllStaffReportlistfem/${year.value}/${month?.label ? month.id : 0}/${companyId}/${userId}`,
              config
            ),
            axios.get(
              `${BemsGraph}/api/EmployeeReport/AllStaffReportlistbem/${year.value}/${month?.label ? month.id : 0}/${companyId}/${userId}`,
              config
            ),
          ]);
          processData(femResponse, bemResponse);
        } else {
          try {
            const [femResponse, bemResponse] = await Promise.all([
              axios.get(
                `${FemsGraph}/api/EmployeeReport/StaffReportlistfem/${hospital.id}/${year.value}/${month?.id}`,
                config
              ),
              axios.get(
                `${BemsGraph}/api/EmployeeReport/StaffReportlistfbem/${hospital.id}/${year.value}/${month?.id}`,
                config
              ),
            ]);
            processData(femResponse, bemResponse);
            console.log()
          } catch (err) {
            console.log(err);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };
  console.log(selectedData, "selectedData")
  const processData = (femResponse, bemResponse) => {
    if (femResponse.data.length > 0 || bemResponse.data.length > 0) {
      femResponse.data.forEach(isPerformance ? addToMapPer : addToMapEff);
      bemResponse.data.forEach(isPerformance ? addToMapPer : addToMapEff);

      setSelectedData({
        month: month,
        year: year,
        level: level,
        hospital: hospital,
        data: Array.from(mergedMap.values()).map((item) => {
          const completedPercentage = isNaN(item.completedPercentage)
            ? ''
            : Number(item.completedPercentage.toFixed(2));

          return {
            ...item,
            hospitalName: hospitalOptions.find(
              (option) => option.id === item.hospitalId
            )?.facilityName,
            completedPercentage, // formatted value
            styles: {
              totalCount: isNaN(item.totalCount) ? 'left' : 'right',
              completedcount: isNaN(item.completedcount) ? 'left' : 'right',
              pendingCount: isNaN(item.pendingCount) ? 'left' : 'right',
              completedPercentage: isNaN(item.completedPercentage) ? 'left' : 'right', // use original for alignment
            },
          };
        }),
      });

      setEnableDownload(true);
    } else {
      setSelectedData({
        month: month,
        year: year,
        level: level,
        data: [],
        hospital: hospital,
      });
      setEnableDownload(true);
    }
  };

  const handleViewButtonClick = () => {
    setIsView(true);
    setOpenModal(true);
  };

  const handleHospitalChange = (newValue) => {
    setHospital(newValue);
  };
  const handleDownloadPDF = async () => {
    // Open the modal and render the content
    setIsView(false); // Ensure the content is visible
    setOpenModal(true);

    // Wait for the modal and component to fully load
    setTimeout(() => {
      if (childRef.current) {
        // Trigger the PDF download method after ensuring the component is loaded
        childRef.current.handleDownloadPDF();
      }

      // Close the modal after the PDF download is initiated
      setTimeout(() => {
        setOpenModal(false);
      }, 1000); // Adjust this timing as needed
    }, 2000); // Adjust this timing to ensure the component is fully rendered
  };

  const handleClose = () => {
    navigate("/dashboard");
    dispatch(setSelectedIndex("SET_INDEX_LABEL", ""));
    dispatch(setHeaderName("SET_HEADER_NAME", "Dashboard"));
  };

  const hanldeCustomData = (data) => {
    setSelectedData((prevState) => ({
      ...prevState, // Spread the existing state
      data: data,     // Update only the `data` property
    }));
  };
  console.log(gridApi, "gridApi")
  return (
    <>
      <PageLoader open={loading} />
      <PageTitle
        title={`Staff ${isPerformance ? "Performance" : "Efficiency"} Report`}
        isReport={openModal}
      />
      <DefaultCard>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label={"Level"}
              options={leveloptions}
              value={level}
              onChange={handleLevelChange}
              disableClearable={true}
              disabled={!access?.canEdit}
            />
          </Grid>
          {level.value === "Hospital" && ( // Conditionally render based on the level selected
            <Grid item xs={6} md={4}>
              <CustomSelectInput
                label="Hospital"
                name="Hospital"
                id="Hospital"
                options={hospitalOptions}
                value={hospital}
                onChange={handleHospitalChange}
                disableClearable={true}
                disabled={!access?.canEdit}
              />
            </Grid>
          )}
          <Grid item xs={6} md={4}>
            <CustomTextField
              label="Option"
              id="Option"
              value={option} // Default value is set to "Employee Performance"
              onChange={handleOptionChange}
              disabled={true}
              isMandatoryField={false}
              isRefilByOtherField={true}
              disableClearable={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Year"
              name="Year"
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder={"Select Year"}
              disableClearable={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Month"
              name="Month"
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder={"Select Month"}
              disabled={!year}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: { xs: "center", md: "end" },
            mt: 3,
          }}
        >
          <Button variant="contained" onClick={handleGetResultClick}>
            Get Result
          </Button>
          <Button variant="outlined" onClick={handleRefresh}>
            Refresh
          </Button>
        </Box>
      </DefaultCard>

      <DefaultCard mt={2}>
        <Stack mb={1} direction={"row"} justifyContent={"end"}>
          <RefreshExportButtons
            exportFunction={() => { }}
            exportData={selectedData?.data}
            handleRefresh={handleGetResultClick}
            refData={gridApi}
            title={`Staff ${isPerformance ? "Performance" : "Efficiency"
              } Report`}
            customPdf={handleDownloadPDF}
            setCustomData={hanldeCustomData}
          />
        </Stack>
        <CustomAgGrid
          rows={selectedData?.data || []}
          columns={columns}
          ref={gridApi}
          setGridApi={setGridApi}
          isLoading={loading}
          setFilterModel={setFilterModel}
          setSortModel={setSortModel}
        />

        <Stack
          direction="row"
          justifyContent="end"
          alignItems="center"
          gap={2}
          mt={2}
        >
          <Button
            variant="contained"
            disabled={!enableDownload}
            onClick={handleViewButtonClick}
          >
            View
          </Button>
          {access?.canPrint && <Button
            variant="contained"
            disabled={!enableDownload}
            onClick={handleDownloadPDF}
          >
            Download
          </Button>}
          <Button variant="outlined" onClick={handleClose}>
            Back
          </Button>
        </Stack>
        <Modal
          open={openModal}
          sx={
            !isView && {
              "& .MuiBackdrop-root": {
                backgroundColor: "transparent",
              },
              top: "-9999px",
              left: "-9999px",
              zIndex: "-1",
            }
          }
        >
          <Box sx={ModalStyle}>
            <StaffReportView
              ref={childRef}
              data={selectedData?.data}
              hospitalOptions={hospitalOptions}
              setOpenModal={setOpenModal}
              setIsView={setIsView}
              hospital={selectedData?.hospital}
              level={selectedData?.level}
              year={selectedData?.year}
              month={selectedData?.month}
              isPerformance={isPerformance}
            />
          </Box>
        </Modal>
      </DefaultCard>
    </>
  );
};

export default StaffReportFetch;
